'use client'

import { useState } from 'react'
import { useRouter } from 'next/navigation'
import Link from 'next/link'
import LinkIcon from '@mui/icons-material/Link'
import TranslateIcon from '@mui/icons-material/Translate'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import styles from './Translations.module.scss'
import { PATHWAY } from '@/modules/httpService'

interface IRowProps {
  lang: string
  langShort: string
  exists: boolean
  slug: string | null
  postId: string | null
  isLoggedIn: boolean
  openSorryModal: () => void
}
function Row ({ lang, exists, slug, postId, langShort, isLoggedIn, openSorryModal }: IRowProps) {
  const router = useRouter()
  const [isLoading, setIsLoading] = useState(false)

  async function createTranslation () {
    setIsLoading(true)
    const res = await PATHWAY.post(`/posts/${postId}/translations`, {
      lang: langShort
    })

    /**
     * navigate to the new translation
     */
    router.push(`/translations/${res.data.data.translations[0].id}`)
  }

  return (
    <div className={styles.row}>
      <div className={styles.languageTitle}>{lang}</div>
      {!isLoading &&
        <div className={styles.languageButton}>
          {exists &&
            <Link href={`/${slug}`}>
              <Button
                variant='text'
                startIcon={<LinkIcon />}
              >
                Article Link
              </Button>
            </Link>
          }
          {!exists &&
            <Button
              variant='outlined'
              startIcon={<TranslateIcon />}
              onClick={() => {
                if (isLoggedIn) createTranslation()
                  if (!isLoggedIn) {
                    openSorryModal()
                  }
              }}
            >
              Translate
            </Button>
          }
        </div>
      }
      {isLoading &&
        <div className={styles.languageButton}>
          <CircularProgress />
        </div>
      }
    </div>
  )
}

export default Row
